import { formatMoneyAmount } from 'enums/regExp';

const formatInputNumberThousand = (val: string | number | undefined) => {
    // formatter pre inputNumber vklada medzery 1000 => 1 000
    if (typeof val === 'number' || typeof val === 'string') {
        const parts = val.toString().split('.');
        parts[0] = parts[0].replace(formatMoneyAmount, ' ');
        return parts.join('.');
    }
    return val || '';
};

export default formatInputNumberThousand;
